import { render, staticRenderFns } from "./SchoolPage.vue?vue&type=template&id=bd2f08ac&"
import script from "./SchoolPage.vue?vue&type=script&lang=js&"
export * from "./SchoolPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports